import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import Order from "@/models/order";

export interface UserOrdersInterface {
  orders: Order[];
  fetching: boolean;
}

const initialState: UserOrdersInterface = {
  orders: [],
  fetching: true,
};

export const userOrdersSlice = createSlice({
  name: "userOrders",
  initialState,
  reducers: {
    updateUserOrders: (
      state,
      action: PayloadAction<Partial<UserOrdersInterface>>
    ) => {
      if (action.payload.fetching !== undefined) {
        state.fetching = action.payload.fetching;
      }
      if (action.payload.orders !== undefined) {
        state.orders = action.payload.orders;
      }
    },
  },
});

export const { updateUserOrders } = userOrdersSlice.actions;

export default userOrdersSlice.reducer;
